import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { ToolsService } from '../../tools/tools.service';
import { AuthPageManageService } from '../../manage/page-manage/auth-page-manage.service';

@Injectable({
  providedIn: 'root'
})

export class SmsnotificationsService {

  // Sms key
  private smsKey$: string |any;

  constructor(
    private baseClient: BaseclientService,
    private tools: ToolsService,
    private authPageServ: AuthPageManageService,
  ) {
    this.authPageServ.getSmsKey().subscribe(smsKeyData => {
      if (smsKeyData) {
        this.smsKey$ = smsKeyData.unique_id;
      }
    });
  }

  /**
   * @description Récupère une sms notification via sa clé
   * @param {string} $smsKey
   * @return {Promise}
   */
  getSmsNotification($smsKey: string): Promise<any> {
    const params = { sms_notification_key: $smsKey };
    return this.baseClient.postBase("getSmsNotification", params);
  }

  /**
   * @description Cloture une sms notification
   * @param {string} $smsKey
   * @param {string} firstname
   * @param {string} lastname
   * @return {Promise}
   */
  closeSmsNotification($smsKey: string, firstname?: string, lastname?: string): Promise<any> {
    const params = {
      sms_notification_key: $smsKey,
      firstname: firstname,
      lastname: lastname
    };
    return this.baseClient.postBase("closeSmsNotification", params);
  }

  /**
   * @description Check si le contexte nécessite de demander un code sms
   * @return {Boolean}
   */
  conditionSms(): boolean {

    return true;

    return (
      window.location.origin.includes("cashless") && this.smsKey$
        || window.location.origin.includes("myfulle") && this.smsKey$
        || window.location.origin.includes("myfulle") && this.tools.getStor("user_id")
        || window.location.origin.includes("myfulle") && this.tools.getStor("id_merchant")
        || !window.location.origin.includes("cashless") && !window.location.origin.includes("myfulle")
        ? true
        : false
    )
  }
}
